export default __webpack_public_path__ + "static/media/mouse.2129802c.png";